<template>
  <standard-layout header="Zu Google Drive hinzufügen">
    <template v-slot:main>
      <div class="mb-3 d-flex">
        <input ref="fileupload"
               type="file"
               class="form-control-file custom-file">
        <button class="btn btn-primary ml-2"
                @click="upload">
          Hochladen
        </button>
      </div>
      <div v-if="message">
        {{message}}
      </div>
    </template>
  </standard-layout>
</template>

<script>
import StandardLayout from "@/layouts/StandardLayout";

export default {
  components: {StandardLayout},
  data() {
    return {
      file: null,
      message: null
    }
  },
  methods: {
    async upload() {
      let formData = new FormData();
      formData.append("file", this.$refs.fileupload.files[0]);
      this.$api.put(`/documents/test`, formData)
      .then(res => this.message = 'File erfolgreich hochgeladen: ' + res.data.id)
      .catch(err => this.handleError(err));
    }
  }
}
</script>
